import { extend } from 'vee-validate'

import {
  required,
  email,
  max,
  numeric,
  min,
  regex,
  confirmed,
  between,
  min_value,
  max_value,
  integer,
  double,
} from 'vee-validate/dist/rules'

extend('integer', {
  ...integer,
  message: 'ต้องเป็นตัวเลขเท่านั้น',
})

extend('required', {
  ...required,
  message: '{_field_} จำเป็นต้องกรอก',
})

extend('confirmed', {
  ...confirmed,
  message: '',
})

extend('numeric', {
  ...numeric,
  message: 'ต้องเป็นตัวเลขเท่านั้น',
})
extend('double', {
  ...double,
  message: 'Please enter number only.',
})

extend('min_value', {
  ...min_value,
  message: '{_field_} ต้องมากกว่า {min}',
})

extend('max_value', {
  ...max_value,
  message: '{_field_} ไม่ควรกรอกเกิน {max}',
})

extend('max_value_srp', {
  ...max_value,
  message: '{_field_} ไม่ควรกรอกเกิน SRP Price',
})

extend('between', {
  ...between,
  message: '',
})

extend('max', {
  ...max,
  message: 'The max length of {length} characters.',
})

extend('min', {
  ...min,
  message: 'The min length of {length} characters.',
})

extend('regex', {
  ...regex,
  message: '',
})

extend('email', {
  ...email,
  message: 'Email is not valid.',
})

extend('decimal', {
  validate: (value, { decimals = '*', separator = '.' } = {}) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false,
      }
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      }
    }
    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`
    const regex = new RegExp(
      `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`,
    )

    return {
      valid: regex.test(value),
    }
  },
  message: 'The {_field_} field must contain only decimal values',
})

extend('url', {
  validate: (value = {}) => {
    let url
    try {
      url = new URL(value)
    } catch (_) {
      return false
    }
    return url.protocol === 'http:' || url.protocol === 'https:'
  },
  message: 'The {_field_} field must url',
})

extend('regexShipDate', {
  validate: (value) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false,
      }
    }
    const regex =
      /([0-31]{2}[\W]([0-12]{2}|(?:มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)+)[\W][0-9]{2,4})/
    // const regex =
    //   /\d{1,2}\s(?:มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)+\s\d{2,4}/

    return {
      valid: regex.test(value),
    }
  },
  message: '{_field_} รูปแบบไม่ถูกต้อง',
})
